import "./Sostenibilidad.css";
import { useState, useEffect } from "react";
import { Col, Container, Row, Card, Alert } from "react-bootstrap";
import EstadoCruce from '../../components/EstadoCruce/EstadoCruce';
import Navegacion from "../../components/Navegacion/Navegacion";
import VolverInicio from "../../components/VolverInicio/VolverInicio";
import Footer from "../../components/Footer/Footer";
import Chat from "../../components/Chat/Chat";
import ImgQuienesSomos from "./src/portada.jpg";
import IconoSostenibilidad from "./src/logos header.png";
import IconoTabsaXS from "./src/mini-logo-tabsa.png";

import ImgComillas from "./src/comillas.png";
import ImgItem1 from "./src/item1.png";
import ImgItem2 from "./src/item2.png";
import ImgItem3 from "./src/item3.png";
import ImgValores from "./src/valores.png";
import ImgOnu from "./src/onu.jpg";

import moment from "moment";

import { useTranslation } from "react-i18next";

function QuienesSomos() {
    const [t, i18n] = useTranslation("global");
    const [showCruce, setShowCruce] = useState(false);
    const [rutas, setRutas] = useState([]);
    const [chatOpen, setChatOpen] = useState(false);
    const [showSelectLanguage, setShowSelectLanguage] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);

  function showItems(chat, calendarioIda, calendarioVuelta, idiomas, login) {
    setChatOpen(chat);
    setShowSelectLanguage(idiomas);
    setLoginOpen(login);
  }

    return (
        <div className="page-sostenibilidad">

          <div className={`slider-top-shadow${!showCruce ? "-off": ""}`}>
            <Navegacion clickOut={showItems} rutas={rutas} showSelectLanguage={showSelectLanguage} />
          </div>

          <div className="div-quienes-somos-s" clickOut={() => { showItems(false, false, false, false, false) }}>
            <img className="img-quienes-somos-t-s" alt={"quienes somos"} src={ImgQuienesSomos} />
          </div>
          <div className="div-quienes-somos-body" clickOut={() => { showItems(false, false, false, false, false) }}>
            
              {/* INICIO VISION */}
              <Row className="row-inicio-vision">
                
                <Col className="col-logo-sostenibilidad d-flex justify-content-center" lg={12} md={12} sm={12} xs={12}>
                  <img className="logo-sostenibilidad" src={IconoSostenibilidad} alt="Sostenibilidad" />
                </Col>

                <Col className="d-flex justify-content-center">
                  <Container>
                    <div className="d-flex flex-row h-5">
                      <div className="flex-shrink-1 h-10">
                        <img src={IconoTabsaXS} className="imgIconoTabsaXS" />
                      </div>
                      <div className="w-100 sostenibilidad-titulo h-10">
                        <div>
                          <p> NUESTRA VISIÓN DE <b>SOSTENIBILIDAD</b></p>
                        </div>
                      </div>
                    </div>
                    
                    <p className="sostenibilidad-vision">
                      En TABSA comprendemos que nuestros servicios deben ser de forma segura y sustentable y es
                      fundamental para lograr nuestra visión de largo plazo el ser referentes en conectividad marítima
                      nacional donde es fundamental establecer una estrecha vinculación con los diversos actores de
                      nuestro entorno. Por ello, promovemos la excelencia, innovación y servicios con altos estándares de
                      seguridad, cuidado del medio ambiente, bienestar de las personas y su entorno y al mismo tiempo
                      identificando mejoras continuas para un generar un impacto positivo cada vez mayor en nuestras
                      actividades y en el bienestar de la comunidad.
                    </p>
                  </Container>
                </Col>

              </Row>

              {/* INICIO PARRAFP */}
              <Row className="row-parrafo">
                <Container className="container-parrafo">
                <div className="div-parrafo">
                  <p className="text-parrafo">
                    La Política de Sostenibilidad de TABSA, 
                    declara que asume un compromiso ético, 
                    basado en lo establecido en nuestra 
                    Misión y Visión en una contribución, 
                    activa y voluntaria al mejoramiento 
                    social, económico y medio ambiental, a 
                    través de la generación y apoyo de 
                    instancias que nos vinculen con nuestros 
                    grupos de interés, mediante el desarrollo 
                    del entorno, clientes, proveedores, 
                    servicios y nuestros colaboradores.
                  </p>
                </div>
                </Container>
              </Row>

              {/* INICIO PILARES */}
              <Row className="row-pilares">
              <Col className="col-logo-sostenibilidad d-flex justify-content-center" lg={12} md={12} sm={12} xs={12}>
                  <img className="logo-sostenibilidad-2" src={IconoSostenibilidad} alt="Sostenibilidad" />
                </Col>

                <Col className="d-flex justify-content-center">
                  <Container>
                    <div className="d-flex flex-row h-5">
                      <div className="flex-shrink-1 h-10">
                        <img src={IconoTabsaXS} className="imgIconoTabsaXS" />
                      </div>
                      <div className="w-100 pilares-titulo h-10">
                        <div>
                          <p> DEFINIMOS <b>TRES PILARES DE ACCIÓN</b> PARA MOVILIZAR NUESTRA GESTIÓN DE SOSTENIBILIDAD</p>
                        </div>
                      </div>
                    </div>

                    <div className="card-pilares">
                  
                      <div className="card-item">
                        <img src={ImgItem1} className="img-items" />
                        <p className="titulo-item-pilares titulo-item-pilares-1"> <b>DESARROLLO SOCIAL</b> </p>
                        <p className="texto-pilares">
                        Participar activamente en el desarrollo de la Región de Magallanes promoviendo la 
                        calidad de vida de las comunidades creando lazos de comunicaciones efectivas y de 
                        confianza, que nos permitan implementar acciones de colaboración conjunta en todas las 
                        comunidades donde estamos presentes
                        </p>
                      </div>

                      <div className="card-item">
                        <img src={ImgItem2} className="img-items" />
                        <p className="titulo-item-pilares titulo-item-pilares-2"> <b>NUESTRAS PERSONAS</b> </p>
                        <p className="texto-pilares">
                        Impulsar el desarrollo, capacitación, bienestar, seguridad y salud de todos nuestros
                        colaboradores, usuarios, prestadores de servicios, promoviendo las buenas prácticas y
                        relaciones laborales con un trato digno, diverso e inclusivo, fomentando la colaboración en
                        un ambiente seguro.
                        </p>
                      </div>

                      <div className="card-item">
                        <img src={ImgItem3} className="img-items" />
                        <p className="titulo-item-pilares titulo-item-pilares-3"> <b>MEDIO AMBIENTE</b> </p>
                        <p className="texto-pilares">
                        Promover la protección del medio ambiente y el cuidado del Mar, mediante prácticas de
                        eficiencia energética tratamiento y disposición final de residuos industriales en nuestras
                        embarcaciones y sitios, mediante una evaluación constante de las distintas tecnologías
                        que contribuyan al menor impacto a la acción climática y fauna marina.
                        </p>
                      </div>

                    </div>
                    
                    
                  </Container>
                </Col>
              </Row>

              {/* INICIO MISION */}
              <Row className="row-mision">
              <Col className="col-logo-sostenibilidad d-flex justify-content-center" lg={12} md={12} sm={12} xs={12}>
                  <img className="logo-sostenibilidad-2" src={IconoSostenibilidad} alt="Sostenibilidad" />
                </Col>

                <Col className="d-flex justify-content-center">
                  <Container>
                    <div className="d-flex flex-row h-5">
                      <div className="flex-shrink-1 h-10">
                        <img src={IconoTabsaXS} className="imgIconoTabsaXS" />
                      </div>
                      <div className="w-100 mision-titulo h-10">
                        <div>
                          <p> NOS BASAMOS EN EL  <b>CUMPLIMIENTO DE NUESTRA MISIÓN/VISIÓN, VALORES CORPORATIVOS</b> Y LA ADHESIÓN A 
                          <b> 5 OBJETIVOS DE DESARROLLO SOSTENIBLE</b> PLANTEADOS POR LA ONU, PARA ALCANZAR NUESTROS OBJETIVOS</p>
                        </div>
                      </div>
                    </div>

                    <Row className="row-mision-vision">
                      <Col className="div-mision " lg={4} md={4} sm={12} xs={12}>

                      <Row>
                        <Col sm={12} xs={12}>
                        <p className="titulo-mision"> <b> MISIÓN </b> </p>
                        <p className="texto-mision"> TABSA es una empresa naviera cuyo 
                          propósito es aportar al desarrollo y bienestar 
                          de las comunidades, conectando personas, 
                          sueños y proyectos con seguridad, eficiencia y 
                          calidad a través de los servicios marítimos 
                          que ofrece. </p>
                        </Col>
                      </Row>

                      <Row className="row-vision">
                        <Col sm={12} xs={12}>
                          <p className="titulo-mision"> <b> VISIÓN </b> </p>
                          <p className="texto-mision"> Ser reconocidos como referentes en 
                          conectividad marítima nacional, 
                          promoviendo la excelencia, innovación y 
                          servicios con altos estándares de seguridad 
                          y cuidado del medio ambiente. </p>
                        </Col>

                      </Row>
                      
                      </Col>

                      <Col className="div-mision div-valores" lg={8} md={4} sm={12} xs={12}>
                        <img src={ImgValores} className="img-valores " />
                      </Col>

                    </Row>
                    
                  </Container>
                </Col>
              </Row>

              {/* INICIO OBJETIVOS */}
              <Row className="row-objetivos">
              <Col className="col-logo-sostenibilidad d-flex justify-content-center" lg={12} md={12} sm={12} xs={12}>
                  <img className="logo-sostenibilidad-2" src={IconoSostenibilidad} alt="Sostenibilidad" />
                </Col>

                <Col className="d-flex justify-content-center">
                  <Container>
                    <div className="d-flex flex-row h-5">
                      <div className="flex-shrink-1 h-5">
                        <img src={IconoTabsaXS} className="imgIconoTabsaXS" />
                      </div>
                      <div className="w-100 objetivo-titulo h-5">
                        <div>
                          <p> OBJETIVOS DE <b>DESARROLLO SOSTENIBLE</b></p>
                        </div>
                      </div>
                    </div>

                    <div className="div-onu">
                      <img className="img-onu" src={ImgOnu} />
                    </div>

                    

                    
                  </Container>
                </Col>
              </Row>


          </div>
          <Chat clickOut={showItems} chatOpen={chatOpen}/>
          <Footer clickOut={showItems} />
          <VolverInicio Path={"/inicio"} Texto={"volver-inicio.volver"} />
        </div>
    );
}

export default QuienesSomos;
